import type { Deposit, User } from '@library/types/payments';
import { DepositsRow } from '@library/components/deposits/DepositsRow';

export interface DepositsRowsProps {
  deposits: Deposit[];
  user: User;
  onDepositRowClick: (
    event: React.MouseEvent<HTMLInputElement | HTMLTableRowElement>,
    deposit: Deposit
  ) => void;
}

export const DepositsRows = ({
  deposits,
  user,
  onDepositRowClick
}: DepositsRowsProps) => {
  const rows: Array<JSX.Element> = deposits?.map((deposit) => {
    return (
      <DepositsRow
        deposit={deposit}
        key={deposit.merchantReferenceId}
        onDepositRowClick={onDepositRowClick}
        user={user}
      />
    );
  });

  return <tbody className="text-2xs xl:text-xs">{rows}</tbody>;
};
